// The screen a COLD browser sees when a signed-in device op runs with no
// device record: "Sign in to continue" (Appendix C, C5). It used to be the
// device-setup ceremony — a passphrase or a device-only passkey minted with
// no account in sight, which is how orphan devices were made (the CCAF
// spinner of 2026-09-04) and how a person could leave with a synced passkey
// that recovered nothing. Every flow that legitimately binds a cold browser
// to an account — sign-up, paper-key restore, passkey restore, pairing, the
// legacy email link — now provisions and protects inside its own screens
// (the email link was missed until 2026-10-16, which left its accounts with
// no way in from a new browser), so anything that
// reaches this overlay is a signed-out visit to a signed-in page. Page
// chrome gates its device ops on a present user, so anonymous visitors
// never meet it.
//
// The awaiting op is REJECTED on dismiss so it does not hang; the sign-in
// returns to this page through fromUri.

import React from 'react'
import { navigate } from 'gatsby'

export interface DeviceSetupOverlayProps {
    /** Rejects the op that raised the prompter (NoWasmDeviceError) and hides
     *  the overlay. */
    onDismiss: () => void
}

function returnPath(): string {
    if (typeof window === 'undefined') return '/'
    return window.location.pathname + window.location.search
}

export const DeviceSetupOverlay: React.FC<DeviceSetupOverlayProps> = ({ onDismiss }) => {
    const signIn = () => {
        const fromUri = returnPath()
        onDismiss()
        void navigate(`/authorize/?fromUri=${encodeURIComponent(fromUri)}`)
    }
    return (
        <div
            style={{
                position: 'fixed',
                inset: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: '#0e0f14',
                padding: '2rem',
                zIndex: 9999,
                overflow: 'auto',
            }}
        >
            <div
                style={{
                    maxWidth: 520,
                    width: '100%',
                    background: 'rgba(255, 255, 255, 0.04)',
                    border: '1px solid rgba(255, 255, 255, 0.1)',
                    borderRadius: 12,
                    padding: '2rem',
                }}
            >
                <h2 style={{ color: '#fff', marginTop: 0 }}>Sign in to continue</h2>
                <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap', marginTop: '1.25rem' }}>
                    <button className="auth-button" data-testid="cold-browser-sign-in" onClick={signIn}>
                        <div />
                        <div />
                        <span>Sign In</span>
                    </button>
                    <button
                        type="button"
                        onClick={onDismiss}
                        style={{ background: 'transparent', border: 'none', color: 'rgba(255, 255, 255, 0.6)', cursor: 'pointer', fontSize: '0.9rem' }}
                    >
                        Not now
                    </button>
                </div>
            </div>
        </div>
    )
}
